import { Disclaimer } from 'src/components/sidebar/disclaimer';
import SidebarPostList from 'src/components/sidebar/sidebarPostList';
import EventType from 'src/constants/footfallEventTypes';
import { trackFootfallEvent } from 'src/utils/footfall';
import Card from 'src/components/card';
import i18n from 'src/utils/translate';
import TopicList from 'src/modules/community/shared/components/sidebar/topicList';
import PostTags from 'src/modules/community/singlePost/components/postTags';
import communitiesWithTopTags from 'src/constants/communitiesWithTopTags';
import SupportingMembersList from 'src/modules/community/shared/components/sidebar/supportingMembersList';
import PinnedPosts from 'src/modules/community/communityPosts/components/sidebar/communityPostsPinnedPosts';
import PopularPosts from 'src/modules/community/communityPosts/components/sidebar/communityPostsPopularPosts';
import ContactAdmins from 'src/components/buttons/contactAdmins';
import { communityAdminRoles } from 'src/constants/roles';
import { useSelector } from 'react-redux';
import { Post, State } from 'src/types';

export default function SinglePostSidebar({ relatedPosts = [] }: { relatedPosts?: Post[]}) {
  const supportingMembers = useSelector(({pages}: State) =>  pages.communityAbout.supportingMembers) || [];
  const { currentCommunity, currentUser } = useSelector(({context}: State) => context);
  const {
    topics,
    pinnedPosts,
    post,
    popularPosts,
  } = useSelector(({pages}: State) => pages.singlePost);

  if (!post || !currentCommunity) return null;

  return (
    <div className="post-sidebar">
      {relatedPosts.length > 0 && (
        <Card title={i18n.t('Related Posts')}>
          <SidebarPostList
            footfallTrackingEvent={EventType.CLICKED_RELATED_POST}
            limit={5}
            posts={relatedPosts}
            onPostClick={() => {
              trackFootfallEvent(EventType.CLICKED, {
                clickType: 'post-side-bar',
                clickMetadata: {
                  section: 'post-side-bar',
                  element: 'related-post',
                },
              });
            }}
            onShowMoreClick={() => {
              trackFootfallEvent(EventType.CLICKED, {
                clickType: 'post-side-bar',
                clickMetadata: {
                  section: 'post-side-bar',
                  element: 'see-more-related-posts',
                },
              });
            }}
          />
        </Card>
      )}

      {supportingMembers.length > 0 &&
        <Card
          seeAllLink={supportingMembers.length > 3 ? `/${currentCommunity.slug}/about#whoweare` : null}
          title={i18n.t('Moderation team')}
        >
          <ContactAdmins
            admins={
              // @ts-expect-error TODO: fix admin / member types
              supportingMembers.filter(member => communityAdminRoles.includes(member.role))
            }
            page="post-page"
          />
          <SupportingMembersList
            isLoggedIn={!!currentUser}
            supportingMembers={supportingMembers.slice(0, 3)}
           />
        </Card>
      }

      {/* communitiesWithTopTags is an hardcoded list */}
      {Object.keys(communitiesWithTopTags).includes(currentCommunity.slug) && (
        <Card title={i18n.t('Top community tags')}>
          <PostTags tags={
            // @ts-expect-error TODO: fix explicit any
            communitiesWithTopTags[currentCommunity.slug]
          } />
        </Card>
      )}

      {!currentUser && popularPosts?.length > 0 &&
        <PopularPosts community={currentCommunity} posts={popularPosts} />
      }
      {currentUser && pinnedPosts?.length > 0 &&
        <PinnedPosts community={currentCommunity} posts={pinnedPosts} />
      }
      {currentUser && topics?.length > 0 &&
        <TopicList community={currentCommunity} topics={topics} />}

      <Card>
        <Disclaimer />
      </Card>
    </div>
  );
}
